import { Grid, Typography } from "@mui/material";
import { t } from "i18next";
import React from "react";
import { TransactionAccordianProps } from "../../../interfaces/CategoryTransactionInterface";

const SuccessTransactionItem = (props: TransactionAccordianProps) => {

    const { successItem, getFlagStatus, transactionItem } = props;
    return (
        <Grid container>
            <Grid container xs={12} sm={12} md={6} lg={4} mb={1}>
                <Grid>
                    <Typography variant="body1">{"【" + t("category_management.from") + "】"}{t("category_management.category_code")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">&nbsp;：{successItem.categoryFrom.categoryCode ??(transactionItem?.successCategory?.length > 0 && transactionItem?.oldCategoryStatus !==null ? transactionItem.productCategory : "-")}&nbsp;/&nbsp;</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">{t("category_management.publication_status")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">：{(transactionItem?.successCategory?.length > 0) ? getFlagStatus(transactionItem?.oldCategoryStatus?.toString()) ?? "-":"-"}</Typography>
                </Grid>
            </Grid>
            <Grid container xs={12} sm={12} md={6} lg={4} mb={1}>
                <Grid>
                    <Typography variant="body1">{"【" + t("category_management.to") + "】"}{t("category_management.category_code")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">&nbsp;：{successItem.categoryTo.categoryCode ??(transactionItem?.oldCategoryStatus !==null ? transactionItem.productCategory : "-")}&nbsp;/&nbsp;</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">{t("category_management.publication_status")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">：{getFlagStatus(successItem.categoryTo?.publicFlag?.toString()??transactionItem?.oldCategoryStatus?.toString()) ?? "-"}</Typography>
                </Grid>
            </Grid>
            <Grid container xs={12} sm={12} md={6} lg={3} mb={1}>
                <Grid>
                    <Typography variant="body1">{t("category_management.time")} ：</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">{transactionItem.lastExecutionTime && transactionItem.lastExecutionTime!== ""  ? transactionItem.lastExecutionTime:"-"}</Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default SuccessTransactionItem;